import { render, staticRenderFns } from "./CargoQuoteAccept.vue?vue&type=template&id=be3f236c&"
import script from "./CargoQuoteAccept.vue?vue&type=script&lang=js&"
export * from "./CargoQuoteAccept.vue?vue&type=script&lang=js&"
import style0 from "./CargoQuoteAccept.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoQuoteAccept.vue"
export default component.exports